/**
 * @description Gestion des inputs de type submit
 */

(() => {
	// Ajout d'un data-style sur les inputs de type submit
	// Dans form.js, la fonction webformsubmt permettra d'ajouter une div parent à ces inputs afin de pouvoir leur appliquer des pseudo elements (réutilisable pour les spe)
	const dataStyle = (selector) => {
		const inputs = document.querySelectorAll(selector);
		inputs.forEach((el) => {
			el.setAttribute('data-style', 'yes');
		});
	};
	dataStyle('input#block-spe-main-search-form');
	dataStyle('input[data-drupal-selector="edit-submit"]');
	dataStyle('input.webform-button--submit');
	dataStyle('#edit-submit-main-search-engine--3');
})();
